const PAGE_TO_PATH = {
  Home: '/',
  About: '/about',
  Services: '/services',
  Outcomes: '/outcomes',
  Process: '/process',
  Contact: '/contact',
};

const pathToPage = (pathname) => {
  switch (pathname) {
    case '/':
      return 'Home';
    case '/about':
      return 'About';
    case '/services':
      return 'Services';
    case '/outcomes':
      return 'Outcomes';
    case '/process':
      return 'Process';
    case '/contact':
      return 'Contact';
    default:
      return 'Home';
  }
};

export { PAGE_TO_PATH, pathToPage };
